import { Component, OnDestroy } from '@angular/core';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { Observable, Subject, takeUntil } from 'rxjs';

import { ApiTcaReportSettings } from 'content-manager/src/app/core/open-api/content-manager-api-client';
import { IProjectPlagiarismReportCheckInfoDialogData } from 'content-manager/src/app/projects/project/plagiarism-reports/check-info-dialog/project-plagiarism-report-check-info-dialog-data';

interface SettingRow {
    label: string;
    key: keyof ApiTcaReportSettings;
}

@Component({
    selector: 'cm-project-plagiarism-report-check-info-dialog',
    templateUrl: './project-plagiarism-report-check-info-dialog.component.html',
    standalone: false
})
export class ProjectPlagiarismReportCheckInfoDialogComponent implements OnDestroy {

    public readonly dialogData: IProjectPlagiarismReportCheckInfoDialogData;

    public requestInProcess: boolean;

    public reportSettings$: Observable<ApiTcaReportSettings>;

    public readonly settingsConfig: SettingRow[] = [
        { label: $localize`Exclude quotes`, key: 'excludeQuotes' },
        { label: $localize`Exclude bibliography`, key: 'excludeBibliography' },
        { label: $localize`Exclude phrases`, key: 'excludeCitations' },
        { label: $localize`Exclude small matches`, key: 'excludeSmallMatches' },
        { label: $localize`Exclude abstract`, key: 'excludeAbstract' },
        { label: $localize`Exclude methods and materials`, key: 'excludeMethods' }
    ];

    private readonly _destroy$ = new Subject<void>();

    constructor(
        dialogConfig: DynamicDialogConfig,
        private readonly _dialogRef: DynamicDialogRef) {
        this.dialogData = dialogConfig.data;
        this.reportSettings$ = dialogConfig.data.getReportSettings$;
    }

    public cancel(): void {
        this._dialogRef.close(false);
    }

    public checkForPlagiarism(): void {

        this.requestInProcess = true;

        this.dialogData.startCheck()
            .pipe(takeUntil(this._destroy$))
            .subscribe(() => {
                this.requestInProcess = true;
                this._dialogRef.close(true);
            });
    }

    public ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }
}
